import LogicSetting from './LogicSetting';

export default LogicSetting;
